import { Roles, UserType } from 'infrastructure/enums';

import type { TFunction } from 'i18next';

export const getStatusLabel = (status: string, t: TFunction) => {
  return {
    approved: t('labels.approved'),
    'in-review': t('labels.inReview'),
    'needs-info': t('labels.needsInfo'),
    draft: t('labels.draft'),
    submitted: t('labels.submitted'),
    denied: t('papCase.deniedLabel'),
  }[status];
};

export const mapLetterContent = (
  content: string,
  values: Record<string, string>,
): string => {
  return content.replace(/\{+(\w+)\}+/g, (match, fieldName) => {
    return fieldName in values ? values[fieldName] : match;
  });
};

export const isEditablePapCase = (userType: UserType, roleNames: Roles[]) => {
  const canCreatePapCaseRoles = [
    Roles.Doctor,
    Roles.PhysicianAssistant,
    Roles.NursePractitioner,
    Roles.RegisteredNurse,
    Roles.QHCP,
    Roles.MedicalAssistant,
  ];

  return (
    userType === UserType.Admin ||
    (userType === UserType.HomeHealth &&
      roleNames.some((role) => canCreatePapCaseRoles.includes(role))) ||
    (userType === UserType.Practice &&
      roleNames.some((role) => canCreatePapCaseRoles.includes(role)))
  );
};
